(() => {
  const SELECTOR = '[data-watermark-protect="true"]';

  function applyProtection(root) {
    // Protect common media elements
    const mediaEls = root.querySelectorAll('img, picture, video, source, model-viewer, canvas');

    mediaEls.forEach((el) => {
      // Stop right-click context menu
      el.addEventListener('contextmenu', (e) => e.preventDefault(), { passive: false });

      // Stop drag-to-desktop / drag image
      el.addEventListener('dragstart', (e) => e.preventDefault(), { passive: false });

      // Some browsers respect these:
      if (el.tagName === 'IMG') {
        el.setAttribute('draggable', 'false');
      }
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(applyProtection);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-apply when Shopify swaps media / sections re-render
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        // If the node itself is protected root
        if (node.matches?.(SELECTOR)) applyProtection(node);

        // Or if it contains protected roots
        node.querySelectorAll?.(SELECTOR).forEach(applyProtection);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
